import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ElasticResult } from '../../core/db/elastic.models';
import { injectPiggyApi, PiggyWithdrawalRequest, PiggyWithdrawalResponse } from './piggy-api';
import { PiggyDbService } from './piggy-db.service';
import { Piggy, PiggyTransaction, PiggyTransactionOption, PiggyTransactionType } from './piggy.models';

@Injectable({ providedIn: 'root' })
export class PiggyService {

  private piggyApi = injectPiggyApi();
  private piggyDbService = inject(PiggyDbService);

  constructor() { }

  /**
   * Get piggy by id
   * @param id piggy id
   * @returns Observable of Piggy
   */
  getPiggy$(id: string): Observable<Piggy> {
    return this.piggyDbService.get$(id);
  }

  /**
   * Get paginated piggy transactions for a user, with ElasticSearch query
   * @param userId User ID to filter transactions
   * @param pagination Pagination parameters (current page and limit)
   * @returns Observable of part of PiggyTransaction with total count for pagination
   */
  getCommissionsDataPage$(userId: string, pagination: { current: number, limit: number; }): Observable<ElasticResult<Partial<PiggyTransaction>>> {
    return this.piggyDbService.getPiggyTransactionsPage$(userId, pagination);
  }

  createWithdrawal(data: PiggyWithdrawalRequest): Promise<PiggyWithdrawalResponse> {
    return this.piggyApi.withdrawal(data);
  }

  /**
   * Get aggregated fee amounts for the current and previous month.
   */
  getMonthlyFeeAmounts(
    userId: string,
    piggyTransactionType: PiggyTransactionType,
    piggyTransactionOption: PiggyTransactionOption
  ): Promise<{ currentMonthAmount: number; previousMonthAmount: number; }> {
    return this.piggyDbService.getMonthlyFeeAmounts(userId, piggyTransactionType, piggyTransactionOption);
  }
}
